import React, { useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import "../../assets/css/authentification/login.css";
import imgGoogle from "../../assets/images/authentification/google.png";
import imgFacbook from "../../assets/images/authentification/facebook.png";
import imgApple from "../../assets/images/authentification/apple.png";
import LoaderAuth from "../../components/loader/authentification/LoaderAuth";
import { ApiUrl } from "../../utils/modules";
import useJournal from "../../hooks/useJournal";
const Login = ({ setAlert }) => {
  const navigate = useNavigate();
  const { createJournal } = useJournal();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { login, verifyCaptchaV3, isLoading, setIsLoading } =
    useContext(AuthContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [resteConnecter, setResteConnecter] = useState(true);

  const generateDeviceId = () => {
    if (crypto.randomUUID) {
      return crypto.randomUUID();
    } else {
      // fallback simple
      return `${Date.now()}-${Math.random()}`;
    }
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    setIsLoading(true);
    localStorage.setItem("navigation", "login");
    if (!executeRecaptcha) {
      createJournal({
        type: 1,
        message: "Recaptcha pas encore chargé",
        page: "Login",
      });
      alert("Recaptcha pas encore chargé");
      setIsLoading(false);
      return;
    }
    try {
      const token = await executeRecaptcha("connexion");
      const captchaRes = await verifyCaptchaV3({ token });

      if (!captchaRes.data.success) {
        setAlert({
          message: "Une activité suspect a été détectée, veuillez réessayer.",
          type: "danger",
        });
        return;
      }
      sessionStorage.setItem("resteConnecter", resteConnecter);
      let deviceId = localStorage.getItem("deviceId");
      if (!deviceId) {
        deviceId = generateDeviceId();
        localStorage.setItem("deviceId", deviceId);
      }
      console.log(deviceId);

      await login({ email, password, deviceId }, setAlert);
    } catch (error) {
       createJournal({
        type: 1,
        message: `Erreur lors de la vérification du captcha : ${
          error?.response?.data?.message || error?.message || "Erreur inconnue"
        }`,
        page: "Login",
      });
      setAlert({
        message: "Une activité suspect a été détectée, veuillez réessayer.",
        type: "danger",
      });
      setIsLoading(false);
    }
  };

  const handleConnectGoogle = async () => {
    setIsLoading(true);
    localStorage.setItem("navigation", "login");
    if (!executeRecaptcha) {
      createJournal({
        type: 1,
        message: "Recaptcha pas encore chargé",
        page: "Login",
      });
      setAlert({
        message: "Captcha non chargé.",
        type: "danger",
      });
      setIsLoading(false);
      return;
    }
    try {
      const token = await executeRecaptcha("login");
      const captchaRes = await verifyCaptchaV3({ token });

      if (!captchaRes.data.success) {
        setAlert({
          message: "Une activité suspect a été détectée, veuillez réessayer.",
          type: "danger",
        });
        setIsLoading(false);
        return;
      }
      let deviceId = localStorage.getItem("deviceId");
      if (!deviceId) {
        deviceId = generateDeviceId();
        localStorage.setItem("deviceId", deviceId);
      }
      window.location.href = `${process.env.REACT_APP_ARTICLE_IMAGE}/auth/google`;
    } catch (error) {
      createJournal({
        type: 1,
        message: `Erreur lors de la vérification du captcha : ${
          error?.response?.data?.message || error?.message || "Erreur inconnue"
        }`,
        page: "Login",
      });
      setAlert({
        message: "Une activité suspect a été détectée, veuillez réessayer.",
        type: "danger",
      });
      setIsLoading(false);
    }
  };

  const handleConnectFacebook = async () => {
    // setIsLoading(false);
    // setAlert({
    //   message: "La connexion avec Facebook sera disponnible bientôt.",
    //   type: "info",
    // });
    localStorage.setItem("navigation", "login");

    let deviceId = localStorage.getItem("deviceId");
    if (!deviceId) {
      deviceId = generateDeviceId();
      localStorage.setItem("deviceId", deviceId);
    }

    window.location.href = `${process.env.REACT_APP_ARTICLE_IMAGE}/auth/facebook?deviceId=${deviceId}`;
  };

  const handleConnectApple = async () => {
    setIsLoading(false);
    setAlert({
      message: "La connexion avec Apple sera disponnible bientôt.",
      type: "info",
    });
  };

  return (
    <>
      {isLoading ? (
        <>
          <LoaderAuth />
        </>
      ) : (
        <>
          <div className="container pb-5 mb-5 pt-5 ">
            <i
              class="bi bi-x-circle login_icon_x"
              role="button"
              onClick={() => navigate("/")}
            ></i>
            <div className="login_navigation">
              <div role="button" onClick={() => navigate("/inscription")}>
                je créer mon compte
              </div>
              <div role="button" className="login_active">
                j'ai déja un compte
              </div>
            </div>
            <div className="login_welcome">
              <h1>Bonjour</h1>
              <p>Connectez avec votre compte</p>
            </div>
            <div className="login_social_buttons">
              <button onClick={handleConnectGoogle}>
                {" "}
                <img src={imgGoogle} alt="google" />
                Continuer avec Google
              </button>
              <button onClick={handleConnectFacebook}>
                {" "}
                <img src={imgFacbook} alt="facebook" />
                Continuer avec Facebook
              </button>
            </div>
            <hr className="login_hr" />
            <form className="login_form" onSubmit={handleSubmit}>
              <input
                type="mail"
                placeholder="Email"
                className="signin_input_text"
                defaultValue={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <div className="w-100 position-relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Votre mot de passe"
                  className="signin_input_text w-100 "
                  defaultValue={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <i
                  class="bi bi-eye position-absolute"
                  style={{ top: "15px", right: "25px", fontSize: "18px" }}
                  onClick={() => setShowPassword(!showPassword)}
                  role="button"
                ></i>
              </div>
              <div className="login_row_between">
                <div className="d-flex justify-content-start align-items-center">
                  <input
                    type="radio"
                    checked={resteConnecter}
                    onClick={() => setResteConnecter(!resteConnecter)}
                  />
                  <span> rester connecté</span>
                </div>

                <span
                  role="button"
                  className="login_forgot_password"
                  onClick={() => navigate("/mot-de-passe-oublie")}
                >
                  Mot de passe oublié ?
                </span>
              </div>

              <button type="submit" className="login_validate">
                SE CONNECTER
              </button>
            </form>
          </div>
        </>
      )}
    </>
  );
};

export default Login;
